import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = {
  id: "eChart",
  style: {"height":"500px","width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 操作 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看完整生命周期")
const _hoisted_6 = {
  id: "customerDetailReport",
  style: {"height":"500px","width":"100%"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

import { ref, computed, reactive, onMounted, nextTick } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { getNumber,exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'
import * as echarts from "echarts";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
   'GET/customer_report/seen_userId':seenUserIdApi,
   'GET/customer_report/seen_org':seenOrgApi,
   'POST/customer_report/customer_report':customerReportApi,
   'POST/customer_report/report_detail':reportDetailApi,
   'POST/customer_report/customer_detail':customerDetailApi,
   'POST/customer_report/export':customerDetailExportApi,
   

} = Api
const store = useStore()


const userId=store.state.userId
const numToFixed=(num:string|number)=>{
    return typeof num == 'number'? Number(num.toFixed(2)):Number(parseFloat(num).toFixed(2))
}
// 筛选栏默认数据
const formData=reactive<any>({
    // roleCategory:'PERSON',
    dateGranularity:"MONTH",
    // visibilityOption:'DEFAULT',
    queryRange:[
        dayjs(Date.now()).subtract(5,'month') ,
        dayjs()
    ],
    userList:[parseInt(store.state.userId)],
    chartType:'orderSum',
    orgList:[]
})
const seenUserList=ref([]) //当前所选团队下的用户
const orgChange=()=>{
    seenUserList.value=[]
    let params={orgList:formData.orgList.join(",")}
    seenUserIdApi(params).then((res:any)=>{
        seenUserList.value=res
        formData.userList=formData.orgList.length?[]:[parseInt(store.state.userId)]
    })
}
// 具有管理权限的团队列表
const orgList=ref([])
const getOrglist=()=>{
    seenOrgApi().then((res:any)=>{
        orgList.value=res
    })
}

const  compare =  (prop:any)=> {
    return function (obj1:any, obj2:any) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
        }
        if (val1 < val2) {
            return -1;
            } else if (val1 > val2) {
            return 1;
            } else {
            return 0;
        }  
        } 
    }


const positionMethod= (point:any, params:any, dom:any)=> {
                // point为tooltip基于父元素的位置，params为tooltip所需的参数
                var x = point[0]; // x轴方向位置
                var y = point[1]; // y轴方向位置
                var width = dom.clientWidth; // tooltip的宽度
                var height = dom.clientHeight; // tooltip的高度
                var gap = 5; // 间距
                var position = [0, 0]; // 偏移量
                // 根据鼠标位置调整tooltip位置
                if (x + width + gap < window.innerWidth) {
                    position[0] = x + gap;
                } else {
                    position[0] = x - width - gap;
                }
                if (y + height + gap < window.innerHeight) {
                    position[1] = y + gap;
                } else {
                    position[1] = y + height - gap;
                }
                return position;
            }
// 加载初始化图表
const initEchart=(res:any)=>{
    const arr=res.sort((a:any, b:any) => a.date.localeCompare(b.date)); //把传入的数据按时间顺序排序
    let date=arr.map((el:any)=>el.date) //获取横坐标
    let allData:any=[] //排序后的所有数据
    arr.map((el:any)=>{ //把所有的数据放在一个数组中
        allData=allData.concat(el.customerReportVoList)
    })
    let lenged=allData.map((el:any)=>el.customerUsername) //获取图表的lenged
    lenged=[...new Set(lenged)] //去重
    let series :any= [];
    lenged.map((item:any) => { //生成  series
        let obj = {
            name: item,
            type: "bar",
            stack: "As",
            data: []
        };
        series.push(obj);
    }); 
    allData.map((item:any) => {//对series 的data进行处理 
        series.map((item1:any) => { 
            if (item1.name == item.customerUsername && date.indexOf(item.date) > -1) {
                item1.propValue=item[formData.chartType]
                // item1.stack=item.customerUsername
                item1.data[date.indexOf(item.date)] = {
                    name:item.customerUsername||"",
                    value: item[formData.chartType]||0,          
                    rtSum:item.rtSum||0, 
                    orderSum:item.orderSum||0, 
                    profitRate:item.profitRate||0,
                    amountProportion:item.amountProportion||0,
                    orderCount:item.orderCount||0,
                }
            }
            
        })
    })
    let option = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
        type: 'shadow'
        },
        position:positionMethod,
        formatter: function (params:any) {
            let result=`
                <table  class="hover-table" border>
                    <tr>
                        <th>客户名称</th>
                        <th>金额</th>
                        <th>订单数量</th>
                        <th>成本</th>
                        <th>利润率</th>
                        <th>占比</th>
                    </tr>                   
            `;
           
           let res=params.filter((el:any)=>{return el.value!=undefined})
            res= res.sort(compare('value')).reverse()
            for (let i = 0; i < res.length; i++) {
                    if(res[i].data){
                        result+=`<tr>
                            <td>${ res[i].data.name}</td>
                            <td>${numToFixed(res[i].data.orderSum)}</td>
                            <td>${res[i].data.orderCount}</td>
                            <td>${numToFixed(res[i].data.rtSum)}</td>
                            <td>${numToFixed(res[i].data.profitRate)}</td>
                            <td>${numToFixed(res[i].data.amountProportion)}</td>
                        </tr>`
                    
                    }
                    
            }
            return res[0].axisValue + `<br />` + result

        }
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
        type: 'category',
        data: xAxisFilter(formData.dateGranularity,date)
        }
    ],
    yAxis: [
        {
        type: 'value'
        }
    ],
    series: series
    }
    nextTick(()=>{
        var myChart = echarts.init(document.getElementById('eChart'));
        myChart.setOption(option,true)
        myChart.getZr().off('click'); //防止触发两次点击事件
        myChart.getZr().on('click', (params) => {
            let pointInPixel = [params.offsetX, params.offsetY];
            if (myChart.containPixel('grid', pointInPixel)) {
                let pointInGrid = myChart.convertFromPixel({
                    seriesIndex: 0
                }, pointInPixel);
                let xIndex = pointInGrid[0]; //索引
                let handleIndex = Number(xIndex);
                let seriesObj = myChart.getOption(); //图表object对象
                var op:any= myChart.getOption();
                //获得图表中点击的列
                var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
                resfreshOrderState(month)
            };
        });
    })
}  
        
const queryRange:any=reactive({
    from:"",
    to:""
})
const resfreshOrderState=(xData:string)=>{
    let {dateGranularity}=formData
    let fromDate=""
    let toDate=""
    switch(dateGranularity){
        case 'MONTH':
            fromDate=dayjs(xData).startOf('month').format('YYYY-MM-DD')   
            toDate=dayjs(xData).endOf('month').format('YYYY-MM-DD')   
        break;
        case 'QUARTER':           
            let arr=xData.split("第")
            let quarter=parseInt(arr[1])              
                fromDate=dayjs(`${parseInt(arr[0])}-${quarter*3-2}`).startOf('month').format('YYYY-MM-DD')   
                toDate=dayjs(`${parseInt(arr[0])}-${quarter*3}`).endOf('month').format('YYYY-MM-DD') 
        break;  
        case 'YEAR':
            fromDate=dayjs(xData).startOf('year').format('YYYY-MM-DD')   
            toDate=dayjs(xData).endOf('year').format('YYYY-MM-DD')
        break;     
    }
    // getOrderStats(fromDate,toDate)
   queryRange.from=fromDate
   queryRange.to=toDate
   getReportDetail()
}
// 获取柱状图数据（模块一）
const echarLoading=ref(false)
const seriesData=ref([])
const getReportData=()=>{
    let {dateGranularity,queryRange,userList,orgList}=formData
    let params={
        dateGranularity,
        userList:userList,
        orgList,
        queryRange:{
            from:dayjs(queryRange[0]).format("YYYY-MM-DD"),
            to:dayjs(queryRange[1]).format("YYYY-MM-DD")
        }
    }
    echarLoading.value=true
    customerReportApi(params).then((res:any)=>{        
        initEchart(res)
        seriesData.value=res
        echarLoading.value=false
    }).catch(()=>{
        echarLoading.value=false
    })
}
const xAxisFilter=(dateType:string,dateArr:any)=>{
    switch(dateType){
        case 'MONTH':
            return dateArr.map((item:any)=>dayjs(item).format("YYYY-MM"));        
        case 'QUARTER':
            return  dateArr.map((item:any)=>{
                    let year=dayjs(item).year()
                    let month=dayjs(item).month()+1
                    return `${year}年第${month/3}季度`
            })
        
        case 'YEAR':
            return dateArr.map((item:any)=>dayjs(item).format("YYYY"));
        
    }
}
// 获取报表详情
const pageInfo=reactive({
    page:1,
    size:10,
    total:0
})
const reportDetailData=ref([])
const tableLoading=ref(false)
const orderTable=ref()
const sortProp=ref<any>('')
const sortOrder=ref<any>(null)
const sortMethod=({column,prop,order}:any)=>{
    sortProp.value=prop
    sortOrder.value=!order?null:order
    getReportDetail()
}
const getReportDetail=()=>{
    let {dateGranularity,userList,orgList}=formData
    let params:any={
        "query": {
            dateGranularity,
            userList:userList,
            orgList,
            queryRange:{
                from:dayjs(queryRange.from).format("YYYY-MM-DD"),
                to:dayjs(queryRange.to).format("YYYY-MM-DD")
            }
        },
        sort: {},
        "page": pageInfo.page,
        "size": pageInfo.size
    }
    let order=!sortOrder.value?'null':sortOrder.value=='ascending'?"ASC":'DESC'
     if(sortProp.value&&sortOrder.value){
        params.sort[sortProp.value]=order
    }else{
        orderTable.value.clearSort()
    }
    tableLoading.value=true
    reportDetailApi(params).then((res:any)=>{
        reportDetailData.value=res.data
        pageInfo.total=res.rowCount
        tableLoading.value=false
    }).catch(()=>{
        tableLoading.value=false
    })
}
const customerDetailList=ref<any>([])
const dialogVisible=ref(false)
const customerDelLoading=ref(false)
const customerDetailReport=ref([])
const dataType=ref('amount')
const showCustomerDetail=(customerUsername:string)=>{
     let {dateGranularity,queryRange,roleCategory,visibilityOption,userList,orgList}=formData
    let params={
        dateGranularity,roleCategory,visibilityOption,
        userList:userList,
        orgList,
        queryRange:{
            from:dayjs(queryRange[0]).format("YYYY-MM-DD"),
            to:dayjs(queryRange[1]).format("YYYY-MM-DD")
        },
        customerUsername
    }
    customerDelLoading.value=true
    dialogVisible.value=true    
    customerDetailList.value=[]     
    customerDetailApi(params).then((res:any)=>{
        customerDetailList.value=[res.total]
        customerDelLoading.value=false  
        customerDetailReport.value=res.detail
        nextTick(()=>{
            initCustomerDetailReport()
        })
    }).catch(()=>{
        customerDelLoading.value=false
    })
}

const initCustomerDetailReport=()=>{
    let option:any = {
        xAxis: {
            type: 'category',
            data: customerDetailReport.value.map((el:any)=>dayjs(el.date).format("YYYY-MM"))
        },
        tooltip: {
        trigger: 'axis',
        axisPointer: {
        type: 'shadow'
        },
        position:positionMethod,
        formatter: function (params:any) {
            let result=`
                <table  class="hover-table" border>
                    <tr>
                        <th>金额</th>
                        <th>订单数量</th>
                        <th>成本</th>
                        <th>利润率</th>
                    </tr>                   
            
                        <tr>
                            <td>${numToFixed(params[0].data.orderSum)}</td>
                            <td>${params[0].data.count}</td>
                            <td>${numToFixed(params[0].data.rtSum)}</td>
                            <td>${numToFixed(params[0].data.profitRate)}</td>
                        </tr>
                      </table>  
                    `
            return params[0].axisValue + `<br />` + result

        }
    },
        legend:{},
        yAxis: {
            type: 'value'
        },
        series:[]
    }   
    switch(dataType.value){
        case 'amount':
            option.legend={data:['销售额','成本']}
            option.series=option.legend.data.map((legend:string)=>{
                return {
                    name:legend,
                    type:'line',
                    data:customerDetailReport.value.map((el:any)=>{
                        return {
                            name:legend,
                            value:legend=='销售额'?el.orderSum:el.rtSum,
                            rtSum:el.rtSum,
                            orderSum:el.orderSum,
                            count:el.count,
                            profitRate:el.profitRate,
                        }
                    })
                }
            })  
            console.log(option.series) 
        break;
        case 'count':
            option.legend={data:['订单数量']}
            option.series=option.legend.data.map((legend:string)=>{
                return {
                    name:legend,
                    type:'line',
                    data:customerDetailReport.value.map((el:any)=>{
                        return {
                            name:'订单数量',value:el.count,
                            rtSum:el.rtSum,
                            orderSum:el.orderSum,
                            count:el.count,
                            profitRate:el.profitRate,
                        }
                    })
                }
            })
        break;
        case 'profitRate':
            option.legend={data:['利润率']}
            option.series=option.legend.data.map((legend:string)=>{
                return {
                    name:legend,
                    type:'line',
                    data:customerDetailReport.value.map((el:any)=>{
                        return {
                            name:'利润率',value:el.profitRate,
                            rtSum:el.rtSum,
                            orderSum:el.orderSum,
                            count:el.count,
                            profitRate:el.profitRate,
                        }
                    })
                }
            })
        break;
    }
    var myChart = echarts.init(document.getElementById('customerDetailReport'));
        myChart.setOption(option,true)
}
const exportLoading=ref(false)
const exportData=async ()=>{
    let {dateGranularity,userList,orgList}=formData
    let params={
        "query": {
            dateGranularity,
            userList:userList,
            orgList,
            queryRange:{
                from:dayjs(queryRange.from).format("YYYY-MM-DD"),
                to:dayjs(queryRange.to).format("YYYY-MM-DD")
            }
        },
        "sort": {
            "count": "DESC"
        },
    }
    exportLoading.value=true
  await  exportHandle(customerDetailExportApi,params)
  exportLoading.value=false

}
const queryRef=ref()

const getData=async (formEl:any)=>{
    if (!formEl) return
    await formEl.validate((valid:any, fields:any) => {
    if (valid) {
        queryRange.from=formData.queryRange[0]
        queryRange.to=formData.queryRange[1]
        getReportData()
        getReportDetail()
    }
})
}
const validatorQueryRange:any=((rule:any, value:any, callback:any)=>{
    // console.log(dayjs(value[1]).year())
    let endYear=dayjs(value[1]).year()
    let startYear=dayjs(value[0]).year()
    let endMonth=dayjs(value[1]).month()
    let startMonth=dayjs(value[0]).month()
    // if(((endYear-startYear)*12+(endMonth-startMonth))>11&&formData.dateGranularity=='MONTH'){
    //     // <el-option label="月度" value="MONTH"/>
    //     //         <el-option label="季度" value="QUARTER"/>
    //     //         <el-option label="年度" value="YEAR"/>
    //     //     </el-select>
    //     callback(new Error("最长可选择时间范围为12个月"))
    // }else{
    //     callback()
    // }
    if(formData.dateGranularity=='MONTH'){
        if((endYear-startYear)*12+(endMonth-startMonth)>11){
            callback(new Error("最长可选择时间范围为12个月"))
        }
    }else if(formData.dateGranularity=='QUARTER'){
        if((endYear-startYear)*12+(endMonth-startMonth)>35){
            callback(new Error("最长可选择时间范围为36个月"))
        }
    }else{
         if((endYear-startYear)*12+(endMonth-startMonth)>143){
            callback(new Error("最长可选择时间范围为12年"))
        }
    }
    callback()
})
  
const rules=reactive({
    queryRange:[{require:true,validator:validatorQueryRange,trigger: ["blur", "change"]}]
})
onMounted(()=>{
    getOrglist()
    seenUserIdApi({orgList:""}).then((res:any)=>{
        seenUserList.value=res
    })
    getData(queryRef.value)



})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Printer = _resolveComponent("Printer")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_form, {
      ref_key: "queryRef",
      ref: queryRef,
      rules: _unref(rules),
      inline: "",
      model: _unref(formData),
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "团队" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              onChange: orgChange,
              multiple: "",
              "collapse-tags-tooltip": "",
              "collapse-tags": "",
              modelValue: _unref(formData).orgList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).orgList) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    key: item.id,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "用户选择" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              style: {"width":"260px"},
              filterable: "",
              multiple: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              modelValue: _unref(formData).userList,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).userList) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seenUserList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.userId,
                    value: item.userId,
                    label: item.realName + '(' + item.username + ')'
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "分类维度" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              onChange: _cache[2] || (_cache[2] = ($event: any) => (initEchart(seriesData.value))),
              modelValue: _unref(formData).chartType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).chartType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "销售额",
                  value: "orderSum"
                }),
                _createVNode(_component_el_option, {
                  label: "利润率",
                  value: "profitRate"
                }),
                _createVNode(_component_el_option, {
                  label: "订单数量",
                  value: "orderCount"
                }),
                _createVNode(_component_el_option, {
                  label: "欠款金额",
                  value: "unclosedAmount"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "数据展示类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).dateGranularity,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).dateGranularity) = $event)),
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "月度",
                  value: "MONTH"
                }),
                _createVNode(_component_el_option, {
                  label: "季度",
                  value: "QUARTER"
                }),
                _createVNode(_component_el_option, {
                  label: "年度",
                  value: "YEAR"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "queryRange",
          label: "时间选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              style: {"width":"260px"},
              modelValue: _unref(formData).queryRange,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).queryRange) = $event)),
              type: "monthrange",
              "range-separator": "To",
              "start-placeholder": "Start month",
              "end-placeholder": "End month"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (getData(queryRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
      [_directive_loading, echarLoading.value]
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "orderTable",
      ref: orderTable,
      data: reportDetailData.value,
      onSortChange: sortMethod
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "customerUsername",
          label: "客户名称",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "owner",
          label: "销售名称",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "count",
          label: "订单个数",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "orderSum",
          label: "订单总金额",
          sortable: "custom",
          formatter: (row)=>numToFixed(row.orderSum)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "rtSum",
          label: "成本总金额",
          sortable: "custom",
          formatter: (row)=>numToFixed(row.rtSum)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "profitRate",
          label: "利润率",
          sortable: "custom",
          formatter: (row)=>numToFixed(row.profitRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "closeCount",
          label: "关单个数",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "deliveredNotClose",
          label: "已交付未关单个数",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "undeliveredCount",
          label: "未交付单个数",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "操作"
        }, {
          header: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "点击导出",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: exportData,
                  class: "ml-10",
                  underline: false,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    (!exportLoading.value)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          size: "18"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Printer)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          size: "18",
                          class: "is-loading"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Loading)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: ($event: any) => (showCustomerDetail(row.customerUsername))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      "current-page": _unref(pageInfo).page,
      "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      "page-sizes": [100, 200, 300, 400],
      layout: " prev, pager, next",
      total: _unref(pageInfo).total,
      onSizeChange: getReportDetail,
      onCurrentChange: getReportDetail
    }, null, 8, ["current-page", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: "客户生命周期",
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (dialogVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: customerDetailList.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "customerUsername",
              label: "客户名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "owner",
              label: "销售名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: "创建日期",
              formatter: (row)=>_unref(dayjs)(row.date).format('YYYY-MM-DD')
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "orderSum",
              label: "销售总金额",
              formatter: (row)=>numToFixed(row.orderSum)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "rtSum",
              label: "成本总金额",
              formatter: (row)=>numToFixed(row.rtSum)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "profitRate",
              label: "利润率",
              formatter: (row)=>numToFixed(row.profitRate)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "count",
              label: "订单个数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "closeCount",
              label: "已关单"
            }),
            _createVNode(_component_el_table_column, {
              prop: "deliveredNotClose",
              label: "已交付未关单"
            }),
            _createVNode(_component_el_table_column, {
              prop: "undeliveredCount",
              label: "未交付"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, customerDelLoading.value]
        ]),
        _createVNode(_component_el_select, {
          modelValue: dataType.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dataType).value = $event)),
          onChange: initCustomerDetailReport,
          style: {"margin":"15px 0"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "金额",
              value: "amount"
            }),
            _createVNode(_component_el_option, {
              label: "利润率",
              value: "profitRate"
            }),
            _createVNode(_component_el_option, {
              label: "订单数量",
              value: "count"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_directive_loading, customerDelLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})